import { render, staticRenderFns } from "./holdDialog.vue?vue&type=template&id=3b5a09fd&scoped=true"
import script from "./holdDialog.vue?vue&type=script&lang=js"
export * from "./holdDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5a09fd",
  null
  
)

export default component.exports